import { OptionPopperSeparator } from '../../../OptionPopper';
import { DropdownItem } from '../types';

export const isOptionPopperSeparator = (item: DropdownItem): item is OptionPopperSeparator =>
  'separator' in item;
